import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { Contact } from '../../models/contact';
import { PoolCustomerContactAutocompleteList } from '../autocomplete-list/customer-contact-autocomplete-list/pool-customer-contact-autocomplete-list';

export const CustomerContactFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (contact: Contact | null) => {
        filter.delete('customerContactId');
        if (contact) {
            updateCache(`customerContact_${contact.id}`, contact?.fullName);
            filter.set('customerContactId', contact.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (customerId: unknown): string => {
        if (typeof customerId !== 'string') {
            return '';
        }

        return getFromCache(`customerContact_${customerId}`) as string;
    };

    registerFilterMap('customerContactId', getDisplayValue);

    return (
        <PoolCustomerContactAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.customerContact" />}
            required={false}
            initialValue={getDisplayValue(filter.get('customerContactId')) ?? ''}
            disablePreventOverflow={true}
        />
    );
};
